const policyRouter = [
    {
        path: "/policies",
        name: "Policies",
        component: () => import("@/Views/Policies/PolicyMain.vue"),
        children: [
            // policy routes
            {
                path: "Guardvary-rules",
                name: "GuardvaryRules",
                component: () => import("@/Views/Policies/GuardvaryRules.vue")
            },
            {
                path: "terms-of-service",
                name: "TermsOfService",
                component: () => import("@/Views/Policies/TermsOfService.vue")
            },
            {
                path: "privacy-policy",
                name: "PrivacyPolicy",
                component: () => import("@/Views/Policies/PrivacyPolicy.vue")
            },
            {
                path: "community-guidelines",
                name: "CommunityGuidelines",
                component: () => import("@/Views/Policies/CommunityGuidelines.vue")
            },
            {
                path: "content-moderation",
                name: "ContentModerationPolicy",
                component: () => import("@/Views/Policies/ContentModerationPolicy.vue")
            },
            {
                path: "user-agreement",
                name: "UserAgreement",
                component: () => import("@/Views/Policies/UserAgreement.vue")
            },
            {
                path: "expert-policy",
                name: "ExpertPolicy",
                component: () => import("@/Views/Policies/ExpertPolicy.vue")
            }


        ]
    }
];

export default policyRouter;